import { ReturnsSortingMode } from "@redotech/redo-return-settings-common/returns-sorting-mode";

export const serviceLevelSort = [
  "verification",
  "grading",
  "quarantine",
] as const;
export type ServiceLevelSort = (typeof serviceLevelSort)[number];

export const prioritySort = [
  "redo_owned_no_refulfillment",
  "redo_owned_refulfillment",
  "high_priority",
  "low_priority",
  "quarantine",
] as const;
export type PrioritySort = (typeof prioritySort)[number];

export type ActiveReturnSort = ServiceLevelSort | PrioritySort;

export const sortingReason = [
  "quarantine",
  "redo_owned",
  "returns_center_refulfillment_enabled",
  "auto_processing_disabled",
  "auto_processing_ineligible",
  "high_priority_merchant",
  "default_low_priority",
] as const;
export type SortingReason = (typeof sortingReason)[number];

export const serviceLevelSortDestinations: Record<ServiceLevelSort, string> = {
  verification: "Verification",
  grading: "Grading",
  quarantine: "Quarantine",
};

export const prioritySortDestinations: Record<PrioritySort, string> = {
  redo_owned_no_refulfillment: "Redo Owned (Liquidate)",
  redo_owned_refulfillment: "Redo Owned (Refulfill)",
  high_priority: "Priority",
  low_priority: "Standard",
  quarantine: "Quarantine",
};

export const sortingReasonLabels: Record<SortingReason, string> = {
  quarantine: "Quarantine",
  redo_owned: "Redo-owned",
  returns_center_refulfillment_enabled: "Refulfillment enabled",
  auto_processing_disabled: "Auto-processing disabled",
  auto_processing_ineligible: "Auto-processing ineligible",
  high_priority_merchant: "Priority merchant",
  default_low_priority: "Standard",
};

export function getDestinationForServiceLevelSort(
  level: ServiceLevelSort,
): string {
  return serviceLevelSortDestinations[level];
}

export function getDestinationForPrioritySort(priority: PrioritySort): string {
  return prioritySortDestinations[priority];
}

export function getDestinationForActiveSort(input: {
  sortingMode: ReturnsSortingMode;
  serviceLevel: ServiceLevelSort;
  priority: PrioritySort;
}): string {
  if (input.priority === "quarantine" || input.serviceLevel === "quarantine") {
    return getDestinationForPrioritySort("quarantine");
  }
  return input.sortingMode === ReturnsSortingMode.PRIORITY
    ? getDestinationForPrioritySort(input.priority)
    : getDestinationForServiceLevelSort(input.serviceLevel);
}
